/**
 * WetlabWorkflowAdapter
 *
 * Thin adapter wiring WetlabWorkflow into the component registry.
 * Mirrors TextEditorAdapter and SpreadsheetAdapter.
 */

import React from 'react';
import { WetlabWorkflow } from './WetlabWorkflow';

export const WetlabWorkflowAdapter: React.FC = () => {
  return <WetlabWorkflow />;
};
